import { WixConnect, WixProvide } from 'widget/player-widget/utils/wix-connect';
import classnames from 'classnames';

import { layoutStyleValues } from 'default-settings';
import socialNetworkNames from 'widget/player-widget/constants/social-networks';

import SocialButton from './social-button/social-button';

import styles from './social-share.styl';


@WixProvide
@WixConnect(styles)
export default class SocialShare extends React.Component {

  static propTypes = {
    appSettings: React.PropTypes.object,
    networks: React.PropTypes.arrayOf(React.PropTypes.string),
    content: React.PropTypes.shape({
      siteUrl: React.PropTypes.string,
      title: React.PropTypes.string,
      description: React.PropTypes.string,
      thumbnailUrl: React.PropTypes.string,
    }),
    className: React.PropTypes.string,
    buttonClassName: React.PropTypes.string,
    linkClassName: React.PropTypes.string,
    popoutOuterClassName: React.PropTypes.string,
    popoutInnerClassName: React.PropTypes.string,
    networksClassNames: React.PropTypes.object,
    openPreviewPrompt: React.PropTypes.func,
    onAfterClicked: React.PropTypes.func,
  };

  static defaultProps = {
    networks: _.values(socialNetworkNames),
    networksClassNames: {},
    openPreviewPrompt: _.noop,
    onAfterClicked: _.noop,
  };

  render() {
    const {
      appSettings,
      networks,
      content,
      className,
      popoutOuterClassName,
      popoutInnerClassName,
      buttonClassName,
      networksClassNames,
      linkClassName,
      openPreviewPrompt,
      onAfterClicked,
    } = this.props;

    const rounded = appSettings.numbers.layoutStyle === layoutStyleValues.ROUND;

    return (
      <div styleName="social-share"
           className={className}>
        {
          _.map(networks, network => (
            <SocialButton styleName="social-button"
                          popoutOuterClassName={popoutOuterClassName}
                          popoutInnerClassName={popoutInnerClassName}
                          className={classnames(buttonClassName, networksClassNames[network])}
                          rounded={rounded}
                          key={network}
                          network={network}
                          content={content}
                          linkClassName={linkClassName}
                          openPreviewPrompt={openPreviewPrompt}
                          onAfterClicked={onAfterClicked} />
          ))
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/social-share/social-share.js